export const NotificationPriority = {
  LOW: 'LOW',
  NORMAL: 'NORMAL',
  HIGH: 'HIGH',
  URGENT: 'URGENT',
} as const;
export type NotificationPriority = (typeof NotificationPriority)[keyof typeof NotificationPriority];

export const NotificationChannel = {
  IN_APP: 'IN_APP',
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  PUSH: 'PUSH',
} as const;
export type NotificationChannel = (typeof NotificationChannel)[keyof typeof NotificationChannel];

export const NotificationType = {
  BOOKING_REQUESTED: 'BOOKING_REQUESTED',
  BOOKING_ACCEPTED: 'BOOKING_ACCEPTED',
  BOOKING_REJECTED: 'BOOKING_REJECTED',
  BOOKING_CONFIRMED: 'BOOKING_CONFIRMED',
  BOOKING_CANCELLED: 'BOOKING_CANCELLED',
  BOOKING_COMPLETED: 'BOOKING_COMPLETED',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  PAYMENT_RECEIVED: 'PAYMENT_RECEIVED',
  PAYOUT_PROCESSED: 'PAYOUT_PROCESSED',
  EVENT_GOING_LIVE: 'EVENT_GOING_LIVE',
  EVENT_CANCELLED: 'EVENT_CANCELLED',
  ENTITLEMENT_WITHDRAWN: 'ENTITLEMENT_WITHDRAWN',
  DISPUTE_OPENED: 'DISPUTE_OPENED',
  DISPUTE_RESOLVED: 'DISPUTE_RESOLVED',
  KYC_APPROVED: 'KYC_APPROVED',
  KYC_REJECTED: 'KYC_REJECTED',
  VENDOR_VERIFIED: 'VENDOR_VERIFIED',
  JOB_LISTING_NEW_INTEREST: 'JOB_LISTING_NEW_INTEREST',
  JOB_LISTING_IOI_REJECTED: 'JOB_LISTING_IOI_REJECTED',
  JOB_LISTING_IOI_SHORTLISTED: 'JOB_LISTING_IOI_SHORTLISTED',
  HIRING_THREAD_NEW_MESSAGE: 'HIRING_THREAD_NEW_MESSAGE',
  CREW_ASSIGNMENT_INVITED: 'CREW_ASSIGNMENT_INVITED',
  CREW_ASSIGNMENT_REJECTED: 'CREW_ASSIGNMENT_REJECTED',
  EVENT_RESCHEDULED: 'EVENT_RESCHEDULED',
  EVENT_CANCELLED_NO_SHOW: 'EVENT_CANCELLED_NO_SHOW',
  EVENT_FAILED_OUTAGE: 'EVENT_FAILED_OUTAGE',
  EVENT_RENAMED: 'EVENT_RENAMED',
  EVENT_DETAILS_UPDATED: 'EVENT_DETAILS_UPDATED',
  STREAM_DISCONNECTED: 'STREAM_DISCONNECTED',
  EVENT_ENDING_SOON: 'EVENT_ENDING_SOON',
  EVENT_ENDED: 'EVENT_ENDED',
  ACCOUNT_SECURITY: 'ACCOUNT_SECURITY',
} as const;
export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];
